import dynamic from 'next/dynamic';

const MyAccount = dynamic(() =>
  process.env.NEXT_PUBLIC_MODULE_SITE !== 'happybet'
    ? import('components/header/myAccount/MyAccount').then((mod) => mod.MyAccount)
    : import('sites/happybet/components/header/myAccount').then((mod) => mod.MyAccount)
);
export type { MyAccountProps as MyAccountType } from './MyAccount';
export { MyAccount };
